import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';

const propTypes = {
  actions: PropTypes.object,
  player: PropTypes.object,
  audioUrl: PropTypes.string,
  videoUrl: PropTypes.string,
  className: PropTypes.string,
};

export default class AudioOnly extends Component {

  constructor(props, context) {
    super(props, context);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const { player: { audioOnly }, actions, onSourceChange } = this.props;
    
    actions.handleAudioOnlyChange(!audioOnly);

    if (onSourceChange) {
      onSourceChange(!audioOnly);
    }
  }

  render() {
    const { player: { audioOnly }, hasAudioSrc, className } = this.props;
    const controlText = audioOnly ? 'Audio Only' : 'Video';
    if (!hasAudioSrc) return null;

    return (
      <button
        ref={
          (c) => {
            this.button = c;
          }
        }
        className={classNames(className, {
          'video-react-audio-only-control': true,
          'video-react-control': true,
          'video-react-button': true,
          'video-react-icon-video-has': !audioOnly,
          'video-react-icon-video-no': audioOnly,
        })}
        type="button"
        tabIndex="0"
        onClick={this.handleClick}
      >
        <span className="video-react-control-text">
          {controlText}
        </span>
      </button>
    );
  }
}

AudioOnly.propTypes = propTypes;
AudioOnly.displayName = 'AudioOnly';
